import { type PaletteMode } from '@mui/material';

// Values come from "2026-CG Brand Guidelines.pdf".
//   Deep Mocha #362f2a  — off-black, the default ground
//   Parchment  #f3eee7  — off-white, the ticket paper and default text
//   Dusty Olive #686d54 — the low-attention neutral accent
// Olive Leaf (#394220) is deliberately unused in this pilot.
export const BRAND = {
  mocha: '#362f2a',
  mochaDeep: '#241f1c',
  parchment: '#f3eee7',
  ivory: '#f5f3e2',
  dustyOlive: '#686d54',
  oliveLeaf: '#394220',
  /** Inactive icon grey, taken from the supplied action SVGs. */
  inactive: '#989490',
  muted: '#b5b0ab',
} as const;

const darkPalette = {
  mode: 'dark' as PaletteMode,
  common: { black: BRAND.mocha, white: BRAND.parchment },
  primary: { main: BRAND.parchment, contrastText: BRAND.mocha },
  secondary: { main: BRAND.dustyOlive, contrastText: BRAND.parchment },
  text: {
    primary: BRAND.parchment,
    secondary: BRAND.muted,
    disabled: BRAND.inactive,
  },
  background: {
    default: BRAND.mocha,
    paper: BRAND.parchment,
    neutral: BRAND.mochaDeep,
  },
  divider: 'rgba(243, 238, 231, 0.18)',
};

export default darkPalette;
